<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :loading="loading"
    :pageLoading="pageLoading"
    :table-headers="tableHeaders"
    :table-items="cces"
    :maskFields="maskFields"
    :indexErrors="indexErrors"
    @clear-index-errors="indexErrors = []"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
  >


    <template slot="action5" slot-scope="{ item }">
      <BaseXmlViewer
        :xmlSource="item.xml"
        :loading="false"
        :xmlTitle="'CC-e-' + item.sequencia"
        @xml-open-action="getCceXml(item, function() {return null;})"
        ref="cceXmlRef"
      />
    </template>

    <template slot="action3" slot-scope="{ item }">
      
      <BasePdfViewer
        :pdfSource="item.pdf"
        :loading="false"
        :pdfTitle="'CC-e-' + item.sequencia"
        @pdf-open-action="getCcePdf(item, function() {return null;})"
        ref="ccePdfRef"
      />
      
    </template>

  </BaseIndex>

</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import BasePdfViewer from "@shared_components/base_pdf_viewer.vue";
import BaseXmlViewer from "@shared_components/base_xml_viewer.vue";
import BasePrint from "@shared_components/base_print.vue";
// import New from "./new.vue";
// import Edit from "./edit.vue";
// import Delete from "./delete.vue";
// import SaleEdit from "@models/sales/edit.vue";
// import cce from "./cces/new.vue";
// import cce_index from "./cces/index_form.vue";

export default {
  data() {
    return {
      statusRequests: 0,
      loading: false,
      pageLoading: false,
      indexErrors: [],
      totalPrice: null,
      totalItems: 0,
      tableHeaders: [
        { text: "Correção", align: "left", sortable: true, value: "correcao" },
        { text: "Sequencia",align: "left", sortable: true, value: "sequencia" },
        { text: "Status", align: "left", sortable: true, value: "status" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'number', mask: 'sequencia' },
        { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    cces: {
      type: Array,
      default: [],
    },
    nfe: {
      type: Object,
      default: null, 
    },
    modelNameSingular: {
      type: String,
      default: "CC-e"
    },
    modelNamePlural: {
      type: String,
      default: "CC-es"
    },
    readIcon: {
      type: String,
      default: "mdi",
    },
  },
  components: {
    BaseIndex: BaseIndex,
    // New: New,
    // Edit: Edit,
    // Delete: Delete,
    BasePdfViewer: BasePdfViewer,
    BaseXmlViewer: BaseXmlViewer,
    // SaleEdit: SaleEdit,
    // BasePrint: BasePrint,
    // cce: cce,
    // cce_index: cce_index,
  },
  created() {
    console.log("indexxxas", this.cces);
    this.totalItems = this.cces.length;
    // this.cces = this.cces;
    // this.loadServerEntry();
  },
  methods: {
    // 
    loadServerEntry: function () {
      this.error = null;
      this.loading = true;
      // var id = this.cashFlow?.id || this.multiSale?.sales[0];
      this.$apollo
        .query({
          query: LOAD_CCES,
          fetchPolicy: "no-cache",
          variables: {
            id: this.nfe.id
          }
        })
        .then(response => {
          this.items = response.data.accountContext.nfe.cces;
          // console.log("ccesind", this.items);
          // this.totalItems = this.items.length;
          // this.items[0]._destroy = false;
          // this.items[1]._destroy = false;

          // this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    refreshNfeStatus: function(nfe) {
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: UPDATE_NFE_STATUS_MUTATION,
          variables: {
            input: {
              nfpeId: nfe.id
            }
          },
        })
        .then(response => {
          //console.log(response.data.retrieveNfpeStatus)
          let errors = response.data.retrieveNfpeStatus.errors;
          if (errors.length){
            // this.$refs.baseIndex.showErrorMessage(errors);
            this.$set(this, 'indexErrors', errors);
            // this.indexErrors = errors;
          } else {
            var response_nfe = response.data.retrieveNfpeStatus.nfpe;
            if (response_nfe) {
              nfe.status = response_nfe.status;
              nfe.statusKey = response_nfe.statusKey;
              nfe.nsXmotivo = response_nfe.nsXmotivo;
            } else {
              this.$set(this, 'indexErrors', ["Não foi possível consultar o status. Tente novamente mais tarde."]);
            }
          }

        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadCcePdf: function(nfe, fileName) {
      this.getCcePdf(nfe, function(pdfFile){
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfFile;
        downloadLink.download = fileName + '.pdf';
        downloadLink.click();
      });
    },
    getCcePdf: function(nfe, callback) {
      if (nfe.pdf) {
        callback(nfe.pdf);
      }
      // console.log("nfeee", nfe);
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_CCE_PDF_MUTATION,
          variables: {
            cceId: nfe.id
          },
        })
        .then(response => {
          var response_data="";
          response_data = response.data.downloadCcePdf;
          var errors = response_data.errors
          // console.log(errors)
          if (errors.length > 0){
            this.indexErrors = errors;
            this.$refs.nfePdfRef.closeDialog();
          } else {
            let pdfFile = "data:application/octet-stream;base64," + response_data.cce.pdf
            this.$set(nfe, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    
    getCceXml: function(nfe, callback) {
      // console.log("chamou XML");
      if (nfe.xml) {
        callback(nfe.xml);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_CCE_XML_MUTATION,
          variables: {
            cceId: nfe.id
          },
        })
        .then(response => {
          var errors = response.data.downloadCceXml.errors;
          // console.log(errors)
          if (errors.length){
            this.indexErrors = errors;
            this.$refs.nfeXmlRef.closeDialog();
          } else {
            let xmlFile = response.data.downloadCceXml.cce.xml;
            this.$set(nfe, 'xml', xmlFile);
            callback(xmlFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
  }
};

const LOAD_ALL_NFES = gql `
  query($input: IndexInputObject!, $saleId: ID) {
  	accountContext {
      nfesIndex(input: $input, saleId: $saleId) {
        count
        nfeViewIndexFilters {
          id
          code
          series
          number
          type
          cfopId
          cfop {
            text
            code
            description
          }
          issuerName
          status
          statusKey
          statusValue
          deliveredReceivedDate
          deliveredReceivedTime
          issueDate
          issueTime
          mailingList
          nsXmotivo
          vNf
          canBeReissued
          customerName
          cashFlow {
            id
            code
            customer {
              id
              name
            }
          }
          cashFlows{
            id
            code
            customer{
              id
              name
            }
          }
        }
        serverFields
        typeOperators
      }
    }
  }
`;

const UPDATE_NFE_STATUS_MUTATION = gql `
  mutation($input: RetrieveNfpeStatusInputObject!) {
    retrieveNfpeStatus(input: $input) {
      nfpe {
        id
        status
        statusKey
        statusValue
        nsXmotivo
      }
      errors
    }
  }
`;

const DOWNLOAD_CCE_PDF_MUTATION = gql `
  mutation($cceId: ID!){
    downloadCcePdf(
      input: {
        cceId: $cceId
    }) {
      cce{
        pdf
      }
      errors
    }
  }
`;


const DOWNLOAD_CCE_XML_MUTATION = gql `
  mutation($cceId: ID!){
    downloadCceXml(
      input: {
        cceId: $cceId
    }) {
      cce{
        xml
      }
      errors
    }
  }
`;

const DOWNLOAD_NFE_CANCELLATION_PDF_MUTATION = gql `
  mutation($nfpeId: ID!){
    downloadNfpeCancellationPdf(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfeCancellationPdf
      }
      errors
    }
  }
`;

const DOWNLOAD_NFE_CANCELLATION_XML_MUTATION = gql `
  mutation($nfpeId: ID!){
    downloadNfpeCancellationXml(input: { nfpeId: $nfpeId}) {
      nfpe{
        nfeCancellationXml
      }
      errors
    }
  }
`;

const SEND_NFE_BY_EMAIL_MUTATION = gql `
  mutation($id: ID!){
    sendNfeByEmail(
        id: $id
    ) {
      success
      errors
    }
  }
`;

const LOAD_CCES = gql`
  query($id: ID!){
    accountContext {
      nfe(id: $id) {
        cces{
          correcao
          sequencia
        }
      }
    }
  }
`;


</script>

<style scoped></style>
